import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY, TOKEN_SCOPE } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { PopularService } from '../constants';

/**
 * 사용자가 가장 많이 사용하는 서비스 목록을 제공하는 훅입니다.
 * @description
 * - Meta Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const usePopularServiceState = () => {
  const {
    state: { scope, region, projectId },
  } = useServiceAppState();
  const { fetchPopularService } = useMetaApiInstance();

  return useQuery<PopularService[]>({
    queryKey: [HOST_QUERY_KEY.GET_POPULAR_SERVICE],
    queryFn: () =>
      fetchPopularService(scope === TOKEN_SCOPE.PROJECT ? { region, projectId } : { region }),
    staleTime: Infinity,
  });
};

export default usePopularServiceState;
